import { render, staticRenderFns } from "./participationsTable.vue?vue&type=template&id=a0040ec2"
import script from "./participationsTable.vue?vue&type=script&lang=js"
export * from "./participationsTable.vue?vue&type=script&lang=js"
import style0 from "./participationsTable.vue?vue&type=style&index=0&id=a0040ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports